import React from "react";
import { Col, Row, Statistic } from "antd";

export default function OrderTotals({ totalItems, total, remaining }) {
  return (
    <Row gutter={16}>
      <Col span={8}>
        <Statistic title="Piezas" value={totalItems} />
      </Col>
      <Col span={8}>
        <Statistic title="Total" prefix="$" precision={2} value={total} />
      </Col>
      <Col span={8}>
        <Statistic title="Restante" prefix="$" precision={2} value={remaining} />
      </Col>
    </Row>
  );
}
